/**
 * Timeout using Promises.
 *
 * @param ms Amount of milliseconds to wait.
 * @returns Promise that resolves after the provided amount of miliseconds.
 */
export default function wait(ms: number) {
    return new Promise((response) => {
        setTimeout(response, ms);
    });
}
